// Definición de tipos para los idiomas soportados
export const SUPPORTED_LANGUAGES = ["en", "es", "et", "zh"] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];